import React, { useEffect } from 'react';

/**
 * The bar fixed to the bottom of the screen on phones and small tablets (decision M3-a, 2026-10-19) that
 * holds a screen's main action (Approve / Reject, Submit, Create PO). Render it only in the compact
 * layout; on laptops the screen keeps its buttons where they always were. A spacer stops the bar from
 * covering the end of the page, and the chat button moves up while the bar is shown.
 */
const StickyActionBar: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    document.body.classList.add('lasheen-has-action-bar');
    return () => document.body.classList.remove('lasheen-has-action-bar');
  }, []);
  return (
    <>
      <div aria-hidden style={{ height: 84 }} />
      <div
        className="lasheen-action-bar"
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 900,
          background: '#fff',
          borderTop: '1px solid #f0f0f0',
          boxShadow: '0 -4px 12px rgba(0,0,0,0.06)',
          padding: '10px 16px calc(10px + env(safe-area-inset-bottom, 0px))',
          display: 'flex',
          gap: 10,
          alignItems: 'center',
        }}
      >
        {children}
      </div>
    </>
  );
};

export default StickyActionBar;
